var React = require('react');
var ReactRouter = require('react-router');

var { Route, IndexRedirect } = ReactRouter;

var App = require('./containers/App');
var SignUp = require('./containers/SignUp');

/* Admin routes */
var AdminLogin = require('./containers/Admin/AdminLogin');
var Dashboard = require('./components/Admin/Dashboard');

/* Client routes */
var Login = require('./containers/Client/Login');
var Home = require('./containers/Client/Home');
var MyOrders = require('./containers/Client/MyOrders');

var getAuth = function(state) {
  return state.auth;
};

var isAuthenticated = function(state) {
  return getAuth(state).authenticated;
};

var isAdmin = function(state) {
	return getAuth(state).isAdmin;
};

var isAuthAdmin = function(state) {
	return (isAuthenticated(state) && isAdmin(state));
};

var requireAuth = (getState) => {
	return (nextState, replace) => {
		if (!isAuthenticated(getState())) {
			replace({
				pathname: '/login',
				state: { nextPathname: nextState.location.pathname }
			});
		}
 	};
};

var requireAuthAdmin = (getState) => {
	return (nextState, replace) => {
		if (!isAuthAdmin(getState())) {
			replace({
				pathname: '/admin/login',
				state: { nextPathname: nextState.location.pathname }
			});
		}
 	};
};

var requireUnauth = (getState) => {
	return (nextState, replace) => {
		if (isAuthenticated(getState())) {
			replace({
				pathname: '/',
				state: { nextPathname: nextState.location.pathname }
			});
		}
	};
};

module.exports = function getRoutes(getState) {
	return (
		<Route path="/" component={App}>
			<IndexRedirect to="home"/>

			<Route path="/login" component={Login}  onEnter={requireUnauth(getState)}/>
			<Route path="/admin/login" component={AdminLogin}  onEnter={requireUnauth(getState)}/>
			<Route path="/new" component={SignUp}  onEnter={requireUnauth(getState)}/>

			<Route path="/admin" onEnter={requireAuthAdmin(getState)}>
				<IndexRedirect to="/admin/dashboard"/>
				<Route path="/admin/dashboard" component={Dashboard} />
			</Route>

			<Route path="/home" component={Home}/>

			<Route path="/user/orders" component={MyOrders} onEnter={requireAuth(getState)}/>
		</Route>
	);
};


// WEBPACK FOOTER //
// ./src/routes.js